import React from "react";
import { parseCustomCss } from "../../Pages/FlexibleLayout/utils";
import imageSource from "../../images/PdfIcon.svg";
const FilePreview = ({ config, classes }) => {
  const customStyles = config?.custom_css ? parseCustomCss(config.custom_css) : {};
  return <img style={{ width: "100%", ...customStyles }} className={classes} src={imageSource} alt="img" />;
};
export default FilePreview;
